<template>
  <v-container
    class="my-6"
  >
    <v-row
      justify="center"
    >
      <v-col
        cols="12"
        sm="8"
      >
        <v-card>
          <v-card-title primary-title>
            <v-row
              class="text-center"
            >
              <v-col cols="12">
                <v-icon x-large class="blue--text text--darken-2">
                  mdi-shield-account
                </v-icon>
              </v-col>
              <v-col
                cols="12"
                v-if="!newSuccessMessage"
              >
                <p class="headline text-weight-black">
                  Hier kannst Du dein Managerbild ändern!
                </p>
                <p class="caption">
                  Dieses Bild wird ggf. nach außen Sichtbar sein und für das Chat- / Nachrichtensystem verwendet.
                </p>
              </v-col>
              <v-col v-else>
                <p class="title green--text">
                  Bild erfolgreich geändert!
                </p>
              </v-col>
            </v-row>
          </v-card-title>

          <v-card-text class="text-center">
            <v-row
              v-if="!newSuccessMessage"
              justify="center"
              align="center"
              no-gutters
            >
              <v-col class="text-right">
                <v-btn
                  text
                  fab
                  small
                  color="primary"
                  top
                  class="mr-2"
                  @click="changeManagerImage(-1)"
                >
                  <v-icon>mdi-arrow-left-bold</v-icon>
                </v-btn>
              </v-col>
              <v-col>
                <v-img :src="managerImageSrc" class="elevation-2" />
              </v-col>
              <v-col class="text-left">
                <v-btn
                  text
                  fab
                  small
                  color="primary"
                  top
                  class="ml-2"
                  @click="changeManagerImage(1)"
                >
                  <v-icon>mdi-arrow-right-bold</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="12">
                <p>Managerbild aussuchen.</p>
              </v-col>
            </v-row>
            <v-row
              v-else
              justify="center"
            >
              <v-col>
                <p class="title green--text text-center">
                  Glückwunsch! Der Server hat Dein neues Bild erfolgreich gespeichert.
                </p>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions
            v-show="!newSuccessMessage"
            class="text-center mb-6 pb-6"
          >
            <v-btn
              outlined
              large
              class="warning--text mx-auto"
              @click="cancelImage()"
              :loading="this.$store.state.loading"
            >
              Abbrechen <v-icon right class="warning--text">
                mdi-cancel
              </v-icon>
            </v-btn>
            <v-btn
              outlined
              large
              class="primary--text mx-auto"
              @click="saveManagerImage()"
              :loading="this.$store.state.loading"
            >
              speichern <v-icon right class="blue--text text--darken-2">
                mdi-send
              </v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

export default {
  name: 'Managerbild',
  metaInfo: {
    title: 'Managerbild ändern'
  },
  data () {
    return {
      managerImageSrc: '/static/game/manager/manager-1.png',
      imageIndex: 0,
      oldImageIndex: 0,
      newSuccessMessage: false
    }
  },
  methods: {
    saveManagerImage: async function () {
      this.newSuccessMessage = await this.$store.dispatch('managerStore/saveManagerImage', { image: this.imageIndex })
    },
    changeManagerImage: function (value) {
      const length = this.$store.state.managerStore.managerImages.length
      const newVal = this.imageIndex + value

      if (newVal <= 0) {
        this.imageIndex = 0
      } else if (newVal >= length) {
        this.imageIndex = length - 1
      } else {
        this.imageIndex = newVal
      }

      this.managerImageSrc = this.$store.state.managerStore.managerImages[this.imageIndex]
      this.$store.commit('managerStore/MANAGER_SET_IMAGE_ID', this.imageIndex)
    },
    cancelImage: function () {
      this.managerImageSrc = this.$store.state.managerStore.managerImages[this.oldImageIndex]
      this.$store.commit('managerStore/MANAGER_SET_IMAGE_ID', this.oldImageIndex)
      this.$router.replace({ path: '/settings' })
    }

  },
  created () {
    // check if user is already logged in and then redirect to home
    if (this.$store.state.matchEvaluationInProgress) {
      this.$router.replace({ path: '/' })
    }
    this.managerImageSrc = this.$store.state.managerStore.managerImages[this.$store.state.managerStore.imageId]
    this.oldImageIndex = this.$store.state.managerStore.imageId
  }
}
</script>
